import * as Yup from 'yup';
import { TargetConfigMetaData } from '../models';
import CleverTap from './index';

export const CLEVERTAP_CONFIG: TargetConfigMetaData = {
  formComponent: CleverTap,

  initialValues: {
    projectId: '',
    passcode: '',
    region: null,
    regionValue: ''
  },

  validationSchema: Yup.object({
    projectId: Yup.string().trim().required(),
    passcode: Yup.string().trim().required(),
    region: Yup.object().required(),
    regionValue: Yup.string().trim().required()
  })
};
